export default "__VITE_ASSET__CYt6KHq7__"